// extracted by mini-css-extract-plugin
export default {"buttonText":"_3PYAiShUS_9aIHVAwT8xww","rankNumber":"_3GgstTcabFMca1EjuouA53"};